/**
 * @generated SignedSource<<bfdd95628e6b03e6e9ec7cb10b66fbc6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ABTestListPage_site$data = {
  readonly id: string;
  readonly slug: string;
  readonly abtestScenarioPageGroups: {
    readonly __id: string;
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly slug: string;
        readonly " $fragmentSpreads": FragmentRefs<"ABTestTableDataRow_abtestScenarioPageGroup">;
      } | null;
    } | null> | null;
  };
  readonly " $fragmentType": "ABTestListPage_site";
};
export type ABTestListPage_site = ABTestListPage_site$data;
export type ABTestListPage_site$key = {
  readonly " $data"?: ABTestListPage_site$data;
  readonly " $fragmentSpreads": FragmentRefs<"ABTestListPage_site">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "abtestScenarioPageGroups"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 120,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "device"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "funnelIds"
    },
    {
      "defaultValue": {
        "direction": "DESC",
        "field": "STATUS"
      },
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageKind"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchTerm"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sourceId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "status"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "withArchived"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ABTestListPage_Query.graphql'),
      "identifierField": "id"
    }
  },
  "name": "ABTestListPage_site",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": "abtestScenarioPageGroups",
      "args": [
        {
          "kind": "Variable",
          "name": "device",
          "variableName": "device"
        },
        {
          "kind": "Variable",
          "name": "funnelIds",
          "variableName": "funnelIds"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "order"
        },
        {
          "kind": "Variable",
          "name": "pageIds",
          "variableName": "pageIds"
        },
        {
          "kind": "Variable",
          "name": "pageKind",
          "variableName": "pageKind"
        },
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        },
        {
          "kind": "Variable",
          "name": "sourceId",
          "variableName": "sourceId"
        },
        {
          "kind": "Variable",
          "name": "status",
          "variableName": "status"
        },
        {
          "kind": "Variable",
          "name": "withArchived",
          "variableName": "withArchived"
        }
      ],
      "concreteType": "AbtestScenarioPageGroupConnection",
      "kind": "LinkedField",
      "name": "__ABTestListPage_abtestScenarioPageGroups_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AbtestScenarioPageGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AbtestScenarioPageGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ABTestTableDataRow_abtestScenarioPageGroup"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Site",
  "abstractKey": null
};
})();

(node as any).hash = "e3c505ae77229f4d9263eb04a0582b4c";

export default node;
